import { z } from 'zod'

/** 企業帳號資料 Schema */
export const corporateAccountInformationSchema = z.object({
  /** 企業帳號ID */
  account: z.string(),
  /** 主帳號 */
  primary: z.boolean(),
  /** 聯絡人名 */
  firstName: z.string(),
  /** 聯絡人姓 */
  lastName: z.string(),
  /** 聯絡人姓名 */
  name: z.string(),
  /** E-mail */
  email: z.string(),
  /** 是否有效 */
  enable: z.boolean()
})

/** 企業帳號資料 */
export interface CorporateAccountInformation
  extends z.infer<typeof corporateAccountInformationSchema> {}
